import { useCallback } from 'react';

export default function AIAvatarHero() {
  const scrollToForm = useCallback(() => {
    const el = document.getElementById('ai-avatar-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <section className="relative min-h-[100svh] sm:min-h-[88vh] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/702e66ab56b55d73639cf50bd928e63d.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D1B35]/90 via-[#1A2B4C]/80 to-[#0D1B35]/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full py-28 sm:py-32">
        <div className="max-w-3xl text-center sm:text-left">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C5A880]/20 border border-[#C5A880]/40 mb-6 sm:mb-8">
            <i className="ri-robot-2-line text-[#C5A880] text-sm"></i>
            <span className="text-[#C5A880] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Нейро-технологии для бизнеса
            </span>
          </div>

          {/* H1 */}
          <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-['Playfair_Display'] font-bold text-white mb-5 sm:mb-6 leading-tight">
            Ваш цифровой двойник:
            <br />
            <span className="text-[#C5A880]">Создавайте видео-контент</span>
            <br />
            24/7 без камер, студий и грима
          </h1>

          <p className="text-sm sm:text-lg text-white/75 font-['Montserrat'] leading-relaxed mb-8 sm:mb-10 max-w-2xl mx-auto sm:mx-0">
            Цифровой двойник — это не просто «красивое видео», а инструмент повышения эффективности вашего маркетинга и оптимизации расходов.
          </p>

          {/* Stats row */}
          <div className="grid grid-cols-3 sm:flex sm:flex-wrap sm:justify-start gap-x-4 sm:gap-x-8 gap-y-4 mb-8 sm:mb-10">
            {[
              { val: '-90%', label: 'расходов на продакшн' },
              { val: '80%', label: 'экономии времени' },
              { val: '20+', label: 'языков' },
            ].map((s) => (
              <div key={s.val} className="text-center min-w-[60px]">
                <div className="text-2xl sm:text-3xl font-bold text-[#C5A880] font-['Playfair_Display']">{s.val}</div>
                <div className="text-white/60 text-xs font-['Montserrat'] mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>

          <button
            onClick={scrollToForm}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-[#C5A880] hover:bg-[#B39770] text-white font-semibold font-['Montserrat'] px-6 sm:px-8 py-4 rounded-xl transition-all duration-300 hover:scale-105 cursor-pointer text-sm sm:text-base leading-snug"
          >
            <i className="ri-calculator-line text-lg flex-shrink-0"></i>
            <span>Рассчитать окупаемость ИИ-аватара для моего бизнеса</span>
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/40 text-2xl"></i>
      </div>
    </section>
  );
}
